var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[(_vm.chartReady)?_c('Pie',{attrs:{"data":_vm.pieChartData,"options":_vm.chartOptions}}):_c('div',[_vm._v("Loading chart...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }